module.exports = __webpack_public_path__ + "static/media/fold-3d.3390ae86.png";